import { render, staticRenderFns, recyclableRender, components } from "./freight-order.vue?vue&type=template&id=c83e4960&scoped=true&"
var renderjs
import script from "./freight-order.vue?vue&type=script&lang=js&"
export * from "./freight-order.vue?vue&type=script&lang=js&"
import style0 from "./freight-order.vue?vue&type=style&index=0&lang=css&"
import style1 from "./freight-order.vue?vue&type=style&index=1&id=c83e4960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83e4960",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/freight-order/freight-order.vue"
export default component.exports